export default "__VITE_ASSET__B7OQi7LC__"